import { ref } from '@vue/composition-api'
import axios from 'axios'
export function useDownloadFile() {
  const loading = ref(false)
  async function download(fileUrl, filename = 'voady.pdf') {
    try {
      fileUrl = fileUrl.replace(new RegExp(/undefined/, 'g'), '')
      loading.value = true
      const apiurl = `${process.env.VUE_APP_API_URL}/api${fileUrl}`
      const token = localStorage.getItem('token')

      const response = await axios.get(apiurl, {
        responseType: 'blob',
        headers: {
          Authorization: token ? `Bearer ${token}` : '',
        },
      })

      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', filename)
      document.body.appendChild(link)
      link.target = '_blank'
      link.click()
      return Promise.resolve()
    } catch (error) {
      console.log(error)
      return Promise.reject()
    } finally {
      loading.value = false
    }
  }
  return { download, loading }
}
